<script>
  import estados from '~js/estados';
  import pessoaServico from '~modulos/acessos/servico';
  
  export default {
    props: {
      pessoa: {
        type: Object,
        required: true,
      },
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        desabilitarEndereco: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      validarDataNascimento() {
        return this.configuracao.permitirCadPFSemDataNascimento ? 'date_format:DD/MM/YYYY' : 'required|date_format:DD/MM/YYYY'
      },
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.pessoa.cep.replace('-', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.pessoa.endereco = cepObj.logradouro.substring(0, 60);
              this.pessoa.bairro = cepObj.bairro.substring(0, 60);
              this.pessoa.cidade = cepObj.localidade.substring(0, 60);
              this.pessoa.estado = cepObj.uf;
              this.pessoa.numero = "";
              this.pessoa.complemento = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      },
    },
    watch: {
      'pessoa.cep': 'getCEP'
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nomePessoaFisicaJuridica')}">
          <label class="control-label" for="nome-terceiro">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-terceiro"
                 v-model="pessoa.nomePessoaFisicaJuridica"
                 data-vv-name="nomePessoaFisicaJuridica"
                 data-vv-as="Nome"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomePessoaFisicaJuridica')">{{ errors.first('nomePessoaFisicaJuridica') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="documento">CPF</label>

          <input type="text"
                 class="form-control"
                 id="documento"
                 v-model="pessoa.cpfCnpj"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
          <label class="control-label" for="nascimento">Data de nascimento</label>

          <input id="nascimento"
                 class="form-control"
                 type="text"
                 v-model="pessoa.dataNascimento"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 data-vv-name="dataNascimento"
                 data-vv-as="data de nascimento"
                 v-validate="validarDataNascimento">

          <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label" for="identidade">Identidade</label>
          
          <input id="identidade"
                 class="form-control"
                 type="text"
                 v-model="pessoa.identidadeInscEstadual"
                 maxlength="20">
        </div>
      </div>

      <div class="col-lg-3" :class="{'has-error': errors.has('inss')}">
        <div class="form-group">
          <label class="control-label" for="inss">INSS <small class="text-muted">(apenas números)</small></label>

          <input id="inss"
                 class="form-control"
                 type="text"
                 v-model="pessoa.inss"
                 v-mascara="'inss'"
                 data-vv-name="inss"
                 data-vv-as="inss"
                 data-vv-delay="1000"
                 v-validate="`inss|inssPisUnico:${this.pessoa.cpfCnpj}`">

          <p class="text-danger" v-show="errors.has('inss')">{{ errors.first('inss') }}</p>
        </div>
      </div>

      <div class="col-lg-3" :class="{'has-error': errors.has('pispasep')}">
        <div class="form-group">
          <label class="control-label" for="pispasep">PISPASEP <small class="text-muted">(apenas números)</small></label>

          <input id="pispasep"
                 class="form-control"
                 type="text"
                 v-model="pessoa.pisPasep"
                 v-mascara="'pispasep'"
                 data-vv-name="pispasep"
                 data-vv-as="pis/pasep"
                 data-vv-delay="1000"
                 v-validate="`pispasep|inssPisUnico:${this.pessoa.cpfCnpj}`">

          <p class="text-danger" v-show="errors.has('pispasep')">{{ errors.first('pispasep') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="pessoa.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 :disabled="desabilitarEndereco"
                 v-mascara="'cep'"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">Endereço</label>

          <input id="endereco"
                 class="form-control"
                 type="text"
                 v-model="pessoa.endereco"
                 data-vv-name="endereco"
                 data-vv-as="endereço"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">Número</label>

          <input id="numero"
                 class="form-control"
                 type="text"
                 v-model="pessoa.numero"
                 data-vv-name="numero"
                 data-vv-as="número"
                 v-validate="'required'"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="pessoa.complemento"
                 maxlength="80">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="pessoa.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="80">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="pessoa.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('estado')}">
          <label class="control-label" for="estado">Estado</label>

          <select id="estado"
                  class="form-control"
                  v-model="pessoa.estado"
                  data-vv-as="estado"
                  data-vv-name="estado"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefone')}">
          <label class="control-label" for="telefone">Telefone 1</label>

          <input id="telefone"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 data-vv-as="telefone 1"
                 data-vv-name="telefone"
                 v-validate="'required'"
                 v-model="pessoa.telefone1">

          <p class="text-danger" v-show="errors.has('telefone')">{{ errors.first('telefone') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="telefone-comercial">Telefone 2</label>

          <input id="telefone-comercial"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="pessoa.telefone2">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="fax">Fax</label>

          <input id="fax"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="pessoa.fax">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('emailTerceiro')}" id="dEmail-terceiro">
          <label class="control-label" for="email-terceiro">E-mail <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input type="text"
                 class="form-control"
                 id="email-terceiro"
                 v-model="pessoa.email"
                 data-vv-as="e-mail"
                 data-vv-name="emailTerceiro"
                 maxlength="300"
                 v-validate="'required'"
                 v-caracteres-email>

          <p class="text-danger" v-show="errors.has('emailTerceiro')">{{ errors.first('emailTerceiro') }}</p>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-pessoa-fisica/componentes/compartilhado/FormDadosCadastrais.vue